// @flow

import FroalaEditor from 'froala-editor';

import {gt} from 'app/utils/i18n';

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.friendlyErrorMessages = function (editor) {
  function handleVideoErrors({code, message}) {
    if (message == null) {
      return;
    }

    switch (code) {
      case 5: {
        const maxSize = parseInt(editor.opts.videoMaxSize / 1000 / 1000);
        const msg = gt(
          'The maximum video size allowed is %sMB. For larger files you can upload to youtube, wistia and many other video hosting providers and use the embed video feature.',
          maxSize
        );
        message += `<div class="mt-2">${msg}</div>`;
        break;
      }
      case 6: {
        let msg = gt('Supported media types: ');

        const mediaTypes = editor.opts.videoAllowedTypes;

        for (let i = 0; i < mediaTypes.length; i += 1) {
          msg += mediaTypes[i];

          if (i !== mediaTypes.length - 1) {
            msg += ', ';
          }
        }
        msg += '. ';
        msg += gt('We are working on supporting more video formats.');
        message += `<div class="mt-2">${msg}</div>`;
      }
    }

    updateVideoErrorMessage(message);

    if (editor.opts.onEditorIsBusyChange) {
      editor.opts.onEditorIsBusyChange(false);
    }
  }

  function handleImageErrors({code, message}) {
    if (message == null) {
      return;
    }

    switch (code) {
      case 5: {
        const maxSize = parseInt(editor.opts.imageMaxSize / 1000 / 1000);
        const msg = gt('The maximum file size allowed is %sMB', maxSize);
        message += `<div class="mt-2">${msg}</div>`;
        break;
      }
      case 6: {
        let msg = gt('Supported image files: ');

        const mediaTypes = editor.opts.imageAllowedTypes;

        for (let i = 0; i < mediaTypes.length; i += 1) {
          msg += mediaTypes[i];

          if (i !== mediaTypes.length - 1) {
            msg += ', ';
          }
        }
        msg += '.';
        message += `<div class="mt-2">${msg}</div>`;
      }
    }

    updateImageErrorMessage(message);

    if (editor.opts.onEditorIsBusyChange) {
      editor.opts.onEditorIsBusyChange(false);
    }
  }

  function updateImageErrorMessage(message) {
    const $popup = editor.popups.get('image.insert');
    const $layer = $popup.find('.fr-image-progress-bar-layer');
    const $message_header = $layer.find('h3');
    $message_header.html(message);
  }

  function updateVideoErrorMessage(message) {
    const $popup = editor.popups.get('video.insert');
    const $layer = $popup.find('.fr-video-progress-bar-layer');
    const $message_header = $layer.find('h3');
    $message_header.html(message);
  }

  // eslint-disable-next-line no-underscore-dangle
  function _init() {
    editor.events.on('image.error', handleImageErrors);
    editor.events.on('video.error', handleVideoErrors);
  }

  // Methods visible outside the plugin.
  return {_init};
};
